module.exports = __webpack_public_path__ + "img/L1060596.76119ac3.jpg";